import "./App.css";
import Process from "./pages/Process/process";
import Login from "./pages/Login/login";
import JdCreation from "./pages/JdCreation/jdCreation"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./auth/protectedRoute";
import Candidates from "./pages/Candidates/candidates";
import Analytics from "./pages/Candidates/Analytics/Analytics";
import Chat from "./pages/Chat/Chat";
import { SidebarProvider } from "./context/SidebarContext";
import Maintenance from "./pages/maintenance/Maintenance";

function App() {
  return (
    <div className="App" style={{ backgroundColor: "#F9F9F9" }}>
      {/* rounte this process page in process url  */}
      <SidebarProvider>

        <Router>

          <Routes>
            <Route path="/" element={<Maintenance />} />
          </Routes>

          <Routes>
            {/* <Route
              path="/process"
              element={
                <ProtectedRoute>
                  <Process />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jd-creation"
              element={
                <ProtectedRoute>
                  <JdCreation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/candidates"
              element={
                <ProtectedRoute>
                  <Candidates />
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics"
              element={
                <ProtectedRoute>
                  <Analytics />
                </ProtectedRoute>
              }
            />
            <Route
              path="/chat"
              element={
                <ProtectedRoute>
                  <Chat />
                </ProtectedRoute>
              }
            />
            <Route path="/login" element={<Login />} /> */}
          </Routes>
        </Router>
      </SidebarProvider>

    </div>
  );
}

export default App;
